import { Controller } from "@hotwired/stimulus"

// Fires a GA4 event when the element is clicked.
//
// Usage:
//   data-controller="analytics-click"
//   data-action="click->analytics-click#track"
//   data-analytics-click-event-value="some_event_name"
//   data-analytics-click-params-value='{"location":"hero"}'
export default class extends Controller {
  static values = { event: String, params: Object }

  track() {
    if (typeof window.gtag !== "function") return
    window.gtag("event", this.eventValue, this.paramsValue)
  }
}
